module.exports = __webpack_public_path__ + "img/材料力学6_9_4.135691d0.jpg";